import moment from 'moment';
import React, { createContext, useContext, useState } from 'react';

const VehicleDataContext = createContext();

export const RangeAnalysisProvider = ({ children }) => {

    const [GlobalData, setGlobalData] = useState({
        "startDate": moment().subtract(7, 'days').format("YYYY-MM-DD"),
        "endDate": moment().subtract(1, 'days').format("YYYY-MM-DD"),
        "VIN_NUM": [],
        "CITY": [],
        "DEPO": [],
    });

    return (
        <VehicleDataContext.Provider value={{ GlobalData, setGlobalData }}>
            {children}
        </VehicleDataContext.Provider>
    );
};

export const useRangeAnalysisVehicleData = () => useContext(VehicleDataContext);



